import { Candidate, CandidateCreationDescriptor } from '$synapse/models';
import { CandidateService } from '$synapse/services';
import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-candidate-update-modal',
  templateUrl: './candidate-update-modal.component.html',
  styleUrls: ['./candidate-update-modal.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class CandidateUpdateModalComponent implements OnInit {
  private readonly _data = inject<Candidate>(MAT_DIALOG_DATA);
  private readonly _candidateService = inject(CandidateService);
  readonly _modalDisplay =
    inject<MatDialogRef<CandidateUpdateModalComponent>>(MatDialogRef);

  candidate: CandidateCreationDescriptor;
  send = false;

  ngOnInit(): void {
    this.candidate = new CandidateCreationDescriptor(
      this._data.firstName,
      this._data.lastName,
      this._data.email,
      [],
      this._data.groups
    );
  }

  submit(): void {
    this.send = true;
    this.updateCandidate().subscribe((candidate: Candidate) => {
      this._modalDisplay.close(candidate);
    });
  }

  private updateCandidate(): Observable<Candidate> {
    return this._candidateService.update(this.candidate, this._data.id);
  }
}
